// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── StatusBadge ─────────────────────────────────────────── */

.scl--cms-components-statusBadge {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 10px;
  gap: 4px;

  height: 24px;
  border-radius: 6px;

  /* Text */
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.1px;

  white-space: nowrap;
  box-sizing: border-box;
}

/* ── Dot ── */

.scl--cms-components-statusBadge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/badge-fs-cp/dynamic-badge-op/css/statusBadge.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;;EAER,YAAY;EACZ,kBAAkB;;EAElB,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;;EAEtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,cAAc;;AAEd;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":["/* ── StatusBadge ─────────────────────────────────────────── */\n\n.scl--cms-components-statusBadge {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 2px 10px;\n  gap: 4px;\n\n  height: 24px;\n  border-radius: 6px;\n\n  /* Text */\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.1px;\n\n  white-space: nowrap;\n  box-sizing: border-box;\n}\n\n/* ── Dot ── */\n\n.scl--cms-components-statusBadge-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
